
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-search",
      function () {
        return require("private-next-pages/trademark-search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-search"])
      });
    }
  